<template>
  <div>
    <LeftSide :status="leftSideStatus" :key_sku="keySku" @filtrate="filtrate" @batchSearch="batchSearch" />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :batchBool="batchBool"
        :key_sku="keySku"
        @clearKey="clearKey"
        @exportItems="exportItems"
      />
      <router-view
        v-if="isSysRights('Order.productSales')"
        :first_loading="firstLoading"
        :items="items"
        :sortType="sortType"
        @openCharts="openCharts"
        @sortItem="sortItem"
      ></router-view>
      <no-rights v-else></no-rights>
      <template v-if="!this.firstLoading">
        <div v-show="this.bottomLoading" class="tx-center mg-t-10">
          {{ $t("order.载入中") }} ...
        </div>
        <div
          v-show="
            !this.bottomLoading &&
            this.items.length &&
            this.page >= this.totalPage
          "
          class="tx-center mg-t-10"
        >
          {{ $t("order.已经是最后一条数据了") }}
        </div>
      </template>
    </div>
    <api-loading :show="loading"></api-loading>
    <Modal
      :modalId="'modalSkuCharts'"
      :home="false"
      :loading="false"
      :size="modalSkuCharts.type == 1 ? 'md' : 'lg'"
      :autoH="true"
    >
      <template slot="header">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{
              modalSkuCharts.type == 1
                ? $t("order.7天销量")
                : $t("order.30天销量")
            }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="body-inner">
          <div
            id="chartWrap"
            :style="{ width: modalSkuCharts.type == 1 ? '550px' : '750px' }"
          ></div>
        </div>
      </template>
    </Modal>
    <batch-search-dialog @handleBatchSearch="handleBatchSearch" :dialog="batchSearchDialog" v-if="batchSearchDialog.visible == true"></batch-search-dialog>
  </div>
</template>

<script>
import LeftSide from "./left-side.vue"; //左边栏
import Header from "./header.vue"; //头
import Modal from "@components/Modal";
import { pagination } from "@components/pagination.js"; //分页
import BatchSearchDialog from '../../distributor/batch-search-dialog.vue'
export default {
  data() {
    return {
      batchSearchDialog:{
        visible: false,
        key: '',
      },
      batchSearchParams: {},
      batchBool: false,
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      loading: true,
      firstLoading: true,
      page: 1,
      rowsPerPage: 10,
      totalPage: 0,
      bottomLoading: false,
      sortType: 1,
      keySku: "",
      items: [],
      modalSkuCharts: {
        type: 1,
        data7: [],
        data: [],
      },
      myChart: null,
    };
  },
  components: {
    BatchSearchDialog,
    LeftSide,
    Header,
    Modal,
    pagination,
  },
  methods: {
    batchSearch(key){
      this.batchSearchDialog = {
        visible: true,
        key: key
      }
    },
    sortItem(sortType) {
      this.sortType = sortType;
      this.resetItems();
      this.getItems();
    },
    openCharts(item, type) {
      // type == 1 7天
      this.modalSkuCharts.type = type;
      this.modalSkuCharts.data7 = item.charts7;
      this.modalSkuCharts.data = item.charts;
      let [xAxis, data] = [[], []];
      this.modalSkuCharts[type == 1 ? "data7" : "data"].forEach((e) => {
        xAxis.push(moment(e.date, "YYYYMMDD").format("MM/DD"));
        data.push(e.val);
      });
      let option = {
        grid: {
          top: 15,
          left: "0",
          right: "0",
          // width: type == 1 ? 550 : 750,
          containLabel: true,
        },
        tooltip: {
          show: true,
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: xAxis,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            type: "line",
            data,
            itemStyle: {
              normal: {
                color: "#17A2B8",
                lineStyle: {
                  color: "#17A2B8",
                },
              },
            },
          },
        ],
      };
      this.myChart.clear();
      this.myChart.setOption(option);
      $("#modalSkuCharts").modal("show");
    },
    exportItems() {
      this.loading = true;
      let url;
      if ($("#ifile").length == 0) {
        $("body").append('<iframe id="ifile" style="display:none"></iframe>');
      }
      let openDownload = (url) => {
        document.getElementById("ifile").src = url;
      };
      $.api_call("api.Order.exportProductSales", {}, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          url = r.Data.Results.url;
          openDownload(url);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    resetItems() {
      this.page = 1;
      this.totalPage = 0;
      this.loading = true;
      this.firstLoading = true;
      this.items = [];
      $("html,body").scrollTop(0);
    },
    clearKey(type) {
      if (type == "sku") {
        this.keySku = "";
      }
      if (type == "batchBool") {
        this.getItems('common');
        return
      }
      //reset
      this.resetItems();
      this.getItems();
    },
    filtrate(sku) {
      this.keySku = sku;
      //reset
      this.resetItems();
      this.getItems('common');
    },
    handleBatchSearch(item){
      this.batchSearchParams = item
      this.batchBool = true
      this.page = 1
      this.rowsPerPage = 10
      this.getItems()
    },

    getItems(batch) {
      if (!this.isSysRights("Order.productSales")) return;
      if (this.bottomLoading) return;
      if(batch == 'common'){
        this.batchBool = false
      }
      this.bottomLoading = true;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        sku: this.keySku,
        sortType: this.sortType,
      };if(Object.keys(this.batchSearchParams).length !== 0 && this.batchBool){
        params = {
          batchSearch: this.batchSearchParams,
          page: this.page,
          rowsPerPage: this.rowsPerPage,
        }
      }
      $.api_call("api.Order.productSales", params, (r) => {
        this.loading = false;
        this.firstLoading = false;
        this.bottomLoading = false;
        if (r.ErrorCode == "9999") {
          if(Object.keys(this.batchSearchParams).length !== 0){
              this.batchSearchDialog.visible = false
            }
          if (r.Data.Results.length) {
            r.Data.Results.forEach((e) => {
              e.charts = [];
              e.charts7 = [];
              for (let k in e.records) {
                e.charts.push({
                  date: k,
                  val: e.records[k],
                });
              }
              for (let i = e.charts.length - 1; i > -1; i--) {
                if (i - e.charts.length > -8) {
                  e.charts7.unshift(e.charts[i]);
                }
              }
              if (!e.salesCnt7) e.salesCnt7 = 0;
              if (!e.salesCnt30) e.salesCnt30 = 0;
              this.items.push(e);
            });
          }
          this.page++;
          this.totalPage = r.Data.Pagination.totalPage;
          this.myChart = echarts.init(document.getElementById("chartWrap"));
          if (
            $("body").height() <= $(window).height() &&
            this.page <= this.totalPage
          )
            this.getItems();
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
  },
  mounted() {
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "transfer.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("transfer.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("transfer.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
        });
      }
    }
    this.getItems();
    $("#modalSkuCharts").on("shown.bs.modal", () => {
      this.myChart.resize();
    });
    $(window).scroll(() => {
      let wH = $(window).height(),
        dH = $("body").height(),
        sT = $(window).scrollTop();
      if (sT + wH >= dH - 30 && this.page <= this.totalPage) {
        this.getItems();
      }
    });
  },
};
</script>

<style lang="less" scoped>
#chartWrap {
  height: 300px;
}
</style>